'use client';

import { useTranslations } from 'next-intl';
import { useState } from 'react';

import {
  SubscriptionFormStatus,
  UiSubscriptionSectionBase
} from '@/fo/ui/subscription/section/base';
import { utilFormatErrorMessages } from '@/fo/util/format-error-messages';

import { hasSubscriptions } from '../api/hasSubscriptions';
import { onSubscribeEmailToNewsletter } from '../api/onSubscribeEmailToNewsletter';
import { validateEmailSchema } from '../api/validateEmail';
import { FeatureSubscriptionSectionBaseProps } from '../lib/FeatureSubscriptionSectionBase';

export const ClientWrapper = ({
  brandImage,
  isSubscribed,
  claimsOnly = false
}: FeatureSubscriptionSectionBaseProps) => {
  const t = useTranslations();

  const [formStatus, setFormStatus] =
    useState<SubscriptionFormStatus>('default');
  const [errorText, setErrorText] = useState<string>('');

  const onSubscribe = async (email: string) => {
    setErrorText((prevValue) => (prevValue ? '' : prevValue));

    const errorMessage = await validateEmailSchema(email);

    if (errorMessage) {
      setFormStatus('error');
      setErrorText(errorMessage);
      return;
    }

    const emailIsSubscribed = await hasSubscriptions(email);

    if (emailIsSubscribed) {
      setFormStatus('error');
      setErrorText(utilFormatErrorMessages(t('emailAlreadySubscribed')) || '');
      return;
    }

    const response = await onSubscribeEmailToNewsletter(email);

    if ('error' in response) {
      setFormStatus('error');
      setErrorText(utilFormatErrorMessages(response.error?.message) || '');
    }

    setFormStatus('success');
  };

  return (
    <UiSubscriptionSectionBase
      brandImage={brandImage}
      onSubscribe={onSubscribe}
      formStatus={formStatus}
      errorText={errorText}
      isSubscribed={isSubscribed || false}
      claimsOnly={claimsOnly}
    />
  );
};
